import React from 'react'
import { Link } from 'react-router-dom'
import PageHeader from '../components/PageHeader'
import ServiceSidebar from '../components/ServiceSidebar'

function ServiceTaxConsulting() {
    return (
        <>
            <PageHeader title="Tax Consulting Services" />

            <div className="page-service-single">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-4">
                            <ServiceSidebar
                                activeService="/service-tax-consulting"
                                ctaTitle="Tax Compliance Made Easy"
                                ctaLabel="Tax inquiries"
                            />
                        </div>
                        <div className="col-lg-8">
                            <div className="service-single-content">
                                <div className="service-featured-image">
                                    <figure className="image-anime reveal">
                                        <img
                                            src={`${process.env.PUBLIC_URL}/images/tax-consulting.jpg`}
                                            alt="Tax Consulting Services"
                                        />
                                    </figure>
                                </div>
                                <div className="service-entry">
                                    <h2 className="text-anime-style-2">
                                        Expert Tax Advisory for Peace of Mind
                                    </h2>
                                    <p className="wow fadeInUp">
                                        Navigating the complexities of Nigerian
                                        taxation can be overwhelming—let our
                                        seasoned tax consultants handle it for
                                        you. We provide comprehensive advisory,
                                        consulting, and computation services
                                        compliant with FIRS regulations for both
                                        individuals and corporations.
                                    </p>
                                    <div className="service-cta-box text-center wow fadeInUp">
                                        <h3>
                                            Ready for stress-free tax
                                            compliance?
                                        </h3>
                                        <Link
                                            to="/contact"
                                            className="btn-default btn-highlighted"
                                        >
                                            Book a Consultation
                                        </Link>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default ServiceTaxConsulting
